import { useMutation } from '@tanstack/react-query';

import { useSnackbar } from 'notistack';
import { EventReportClient, IncidentEventReportMutationRequest, ProblemDetails } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const eventReportClient = new EventReportClient(apiBaseUrl);

function useRemoveFromIncident() {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<void, ProblemDetails, IncidentEventReportMutationRequest>({
    mutationKey: [queryKeys.EventReport.RemoveFromIncident],
    mutationFn: (request: IncidentEventReportMutationRequest) => eventReportClient.removeFromIncident(request),
    onError: (error) => {
      const statusMessage = error.status === 409
        ? 'Form data has changed on the server, please refresh the page and try again.'
        : 'An unexpected error has occurred.';

      enqueueSnackbar(statusMessage, { variant: 'error', persist: true });
    },
  });
}

export default useRemoveFromIncident;
